// extracted by mini-css-extract-plugin
module.exports = {"root":"EABD2ScreenContainer_root__2YIQy","fadeIn":"EABD2ScreenContainer_fadeIn__2blE0"};